import React, { useState } from "react";
import { setTitle } from "../../../helpers/MetaTag";
import ProfileStatistics from "../../../components/sections/front/User/ProfileStatistics";
import CurrentSubscription from "../../../components/sections/front/User/CurrentSubscription";
import CurrentAddress from "../../../components/sections/front/User/CurrentAddress";
import SubscriptionList from "../../../components/sections/front/User/SubscriptionList";
import useFetch from "../../../hooks/useFetch";
import { subscriptionListFont } from "../../../services/subscriptionService";
import dayjs from "dayjs";
import { useDebounce } from "../../../hooks/useDebounce";

const Subscriptions = () => {
  setTitle("Memory Doddle | Plan");
  const [filters, setFilters] = useState({
    status: [],
    startDate: null,
    endDate: null,
    limit: 10,
    page: 1,
    sortQuery: "-createdAt",
    // keyword: "",
  });
  const [keyword, setKeyword] = useState("");
  const debouncedKeyword = useDebounce(keyword, 300);

  const {
    data: subscriptiondata = {},
    isLoading,
    refetch,
  } = useFetch({
    dependencies: ["subscription", filters, debouncedKeyword],
    fetchFunction: async () => {
      const query = {
        // ...(search && { keyword: search }),
        ...(debouncedKeyword && { keyword: debouncedKeyword }),
        page: filters.page,
        limit: filters.limit,
        sortQuery: filters.sortQuery,
        ...Object.fromEntries(
          filters.status.map((val, i) => [`status[${i}]`, val])
        ),
        ...(filters.startDate && {
          startDate: dayjs(filters.startDate).format("YYYY-MM-DD"),
        }),
        ...(filters.endDate && {
          endDate: dayjs(filters.endDate).format("YYYY-MM-DD"),
        }),
      };

      const res = await subscriptionListFont(query);
      return res?.docs || {};
    },
  });

  // const subscriptiondata = [
  //   {
  //     _id: 1,
  //     name: "Premium Doodle",
  //     status: "Active",
  //     startdate: "6 June, 2025",
  //     enddate: "30 June, 2025",
  //     transactionId: "TXN0095862",
  //   },
  //   {
  //     _id: 2,
  //     name: "Premium Doodle",
  //     status: "Expiring",
  //     startdate: "15 May, 2025",
  //     enddate: "15 June, 2025",
  //     transactionId: "TXN0095863",
  //   },
  //   {
  //     _id: 3,
  //     name: "Premium Doodle",
  //     status: "Cancelled",
  //     startdate: "15 April, 2025",
  //     enddate: "15 May, 2025",
  //     transactionId: "TXN0095864",
  //   },
  //   {
  //     _id: 4,
  //     name: "Standard Doodle",
  //     status: "Expired",
  //     startdate: "6 March, 2025",
  //     enddate: "15 April, 2025",
  //     transactionId: "TXN0095865",
  //   },
  //   {
  //     _id: 5,
  //     name: "Basic Doodle",
  //     status: "Expired",
  //     startdate: "15 February, 2025",
  //     enddate: "15 March, 2025",
  //     transactionId: "TXN0095866",
  //   },
  // ]

  return (
    <div className="relative space-y-5">
      <div className="grid grid-cols-3 gap-4 3xl:gap-6 items-start">
        <div className="relative col-span-2">
          <SubscriptionList
            title={"Plan"}
            data={subscriptiondata}
            isLoading={isLoading}
            isSort={true}
            isfilter={true}
            // onSearch={(val) =>
            //   setFilters((prev) => ({
            //     ...prev,
            //     keyword: val,
            //     page: 1,
            //   }))
            // }
            onSearch={(val) => {
              setKeyword(val);
              setFilters((prev) => ({ ...prev, page: 1 }));
            }}
            onSortChange={(val) =>
              setFilters((prev) => ({
                ...prev,
                sortQuery: val,
                page: 1,
              }))
            }
            onFilterChange={(newFilters) =>
              setFilters((prev) => ({
                ...prev,
                ...newFilters,
                page: 1,
              }))
            }
            onPageChange={(selectedPage) =>
              setFilters((prev) => ({
                ...prev,
                page: selectedPage,
              }))
            }
            currentPage={subscriptiondata?.metadata?.page || 1}
            totalPages={subscriptiondata?.metadata?.totalPages || 1}
            pagination={true}
            // onSearch={setSearch}
            // onSortChange={(val) => setSort(val)}
            // onFilterChange={(newFilters) => setFilters(newFilters)}
          />
        </div>
        <div className="relative grid grid-cols-1 gap-4">
          <ProfileStatistics />
          <CurrentSubscription />
          <CurrentAddress />
        </div>
      </div>
    </div>
  );
};

export default Subscriptions;
